import { Button } from '@/components/Button';
import styles from './Ticket.module.scss';
import { Sizes, TicketsType } from '@/types';
import { Popover } from '@/components/Popover';
import { Placement } from '@/components/Popover/types';
import { useState } from 'react';
import { formatPrice } from '@/utils/formatPrice';

import { getPersonWord } from '@/utils/getPersonWord';
import cn from 'classnames';
import { useRouter } from 'next/router';
import { parseText } from '@/utils/parseText';

export function Ticket({
  name,
  id,
  text,
  help,
  price,
  numberOfPersons,
  button,
  size,
  link,
  className,
}: TicketsType & { className?: string }) {
  const [tooltipOpened, setTooltipOpened] = useState(false);
  const router = useRouter();

  const ticketClassName = cn(
    styles.ticket,
    {
      [styles.big]: size === 'big',
    },
    'custom-ticket',
  );

  const contentClassName = cn(styles.text, className);

  const iconClassName = cn({
    [styles.icon]: !tooltipOpened,
    [styles.active]: tooltipOpened,
  });
  const persons = getPersonWord(numberOfPersons, router.locale);

  return (
    <div className={ticketClassName}>
      <div className={styles.header}>
        <p className={styles.bold}>{name}</p>
        {help && (
          <div className={styles.anchor}>
            <div data-tooltip-id={id.toString()} />
            {tooltipOpened ? (
              <img
                src="/svg/close-square.svg"
                width={24}
                height={24}
                alt="close-tooltip"
                className={styles.close}
                onClick={() => setTooltipOpened(false)}
              />
            ) : (
              <div
                className={iconClassName}
                onClick={() => setTooltipOpened(true)}
              >
                ?
              </div>
            )}
          </div>
        )}
        <Popover
          anchor={id.toString()}
          placement={Placement.BottomEnd}
          clickable
          opened={tooltipOpened}
          setOpened={setTooltipOpened}
          offset={0}
        >
          {parseText(help)}
        </Popover>
      </div>
      <div className={styles.price}>
        <div className={cn(styles.priceNumber, 'custom-ticket-price')}>
          {formatPrice(price)} ₽
        </div>
        <div className={styles.persons}>
          <img
            loading="lazy"
            src="/svg/group.svg"
            width={16}
            height={16}
            alt="for-one-person"
          />
          <span>
            {router.locale === 'ru' && 'На'} {numberOfPersons} {persons}
          </span>
        </div>
      </div>
      {text ? (
        <div className={contentClassName}>{parseText(text)}</div>
      ) : (
        <div className={styles.empty} />
      )}
      <Button
        text={button}
        onClick={() => router.push(link)}
        size={Sizes.Small}
        className={!link ? styles.disabled : ''}
      />
    </div>
  );
}
